import React from 'react';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import styles from './reportes.module.scss';

const ReportHazard = ({ airport }) => {
  const history = useHistory();
  const handleReview = () => {
    history.push(`/safety_management/us/${airport.code}`);
  };
  return (
    <div className={styles.report}>
    <div className={styles.title} style={{ marginLeft: '40px' }}>
    <FormattedMessage id="safetyManagementSystem.title" defaultMessage="Safety Management System" />
    <i role="presentation"
    onClick={handleReview}
    className={`${styles.review} fa-solid fa-arrow-up-right-from-square`}
    style={{ marginLeft: '45px', cursor: 'pointer' }}
    onKeyPress={handleReview} />
    </div>
    </div>
  );
};

export default ReportHazard;
